import { InputRule } from "@handlewithcare/prosemirror-inputrules";
import { type NodeType } from "prosemirror-model";
import { type EditorState, TextSelection } from "prosemirror-state";

// Match [[text]] where text is one or more characters that aren't ].
// This works just like **bold** or ~~strike~~ — typing the closing ]]
// converts the whole [[text]] span into a page_link atom node.
//
// NOTE: This regex does NOT handle titles containing ] characters (e.g., [[Title]Rest]]).
// The micromark parser (micromark-page-link.ts) does handle escaped ] via \], but this
// input rule is intentionally simpler. In practice, the autocomplete picker is the primary
// insertion path, and titles rarely contain ] characters.
const pageLinkRegex = /\[\[([^\]]+)]]$/;

export const pageLinkRule = (nodeType: NodeType): InputRule => {
	const matchHandler = function (
		state: EditorState,
		match: RegExpMatchArray,
		start: number,
		end: number
	) {
		const pageTitle = match[1]?.trim();
		if (!pageTitle) {
			return null;
		}

		const node = nodeType.create({ pageTitle });
		let tr = state.tr.replaceWith(start, end, node);
		// Move cursor after the inserted atom node
		tr = tr.setSelection(TextSelection.create(tr.doc, start + node.nodeSize));
		return tr;
	};

	return new InputRule(pageLinkRegex, matchHandler);
};
